// SPDX-License-Identifier: AGPL-3.0-or-later

export function fromHexCodePoint(hex: string): string {
	return String.fromCodePoint(Number.parseInt(hex, 16));
}

export function getTwemojiURL(_codePoints: string): null {
	return null;
}

export function getEmojiURL(_unicode: string): null {
	return null;
}
